// @owners { team: patients-team }
import { Body, Column, H1, Illustration, Row } from '@alto/design-system';
import React from 'react';
import { getImage } from '~shared/assets/images/getImage';
import { BackLink } from '~web/components/BackLink';

export const PrefsConfirmationPage = () => {
  return (
    <Column gap="LG">
      <Row center>
        <Illustration
          accessibilityLabel="bike courier"
          source={getImage('bikeCourier')}
          size="xxl"
        />
      </Row>
      <H1 center>Preferences Saved!</H1>
      <Body
        center
        fontFamily="semibold"
      >
        Thanks for updating your email preferences. Please allow 48 hours for all systems to update.
      </Body>
      <Row center>
        <BackLink
          href={window.location.href}
          text="Back to preferences"
        />
      </Row>
    </Column>
  );
};
